<template>
  <v-window-item value="general">
    <v-card-text>
      <v-card variant="outlined" class="mb-4">
        <v-card-title class="text-subtitle-1">
          <v-icon class="me-1" size="small">mdi-briefcase</v-icon>
          Official Information
        </v-card-title>
        <v-card-text>
          <v-card variant="tonal" class="py-4">
            <v-row>
              <v-col cols="12" md="6">
                <v-list-item prepend-icon="mdi-card-account-details" title="Employee Code" :subtitle="(userGeneralInfoData?.employee?.code) || 'N/A'" />
                <v-list-item prepend-icon="mdi-account-group" title="Employee Type" :subtitle="(userGeneralInfoData?.employee?.employee_type?.name) || 'N/A'" />
                <v-list-item prepend-icon="mdi-domain" title="Department" :subtitle="(userGeneralInfoData?.employee?.department?.name) || 'N/A'" />
                <v-list-item prepend-icon="mdi-badge-account" title="Designation" :subtitle="(userGeneralInfoData?.employee?.designation?.name) || 'N/A'" />
                <v-list-item prepend-icon="mdi-office-building" title="Branch" :subtitle="(userGeneralInfoData?.employee?.branch?.name) || 'N/A'" />
                <v-list-item prepend-icon="mdi-phone-office" title="Office Phone" :subtitle="(userGeneralInfoData?.employee?.phone_office) || 'N/A'" />
              </v-col>
              <v-col cols="12" md="6">
                <v-list-item prepend-icon="mdi-phone" title="Residence Phone" :subtitle="(userGeneralInfoData?.employee?.phone_residence) || 'N/A'" />
                <v-list-item prepend-icon="mdi-calendar-start" title="Joining Date" :subtitle="(userGeneralInfoData?.employee?.joining_date) || 'N/A'" />
                <v-list-item prepend-icon="mdi-calendar-check" title="Appointment Date" :subtitle="(userGeneralInfoData?.general_info?.appointment_date) || 'N/A'" />
                <v-list-item prepend-icon="mdi-calendar-check" title="Confirmation Date" :subtitle="(userGeneralInfoData?.general_info?.confirmation_date) || 'N/A'" />
                <v-list-item prepend-icon="mdi-map-marker" title="Office Location" :subtitle="(userGeneralInfoData?.general_info?.office_location) || 'N/A'" />
                <v-list-item prepend-icon="mdi-account-clock" title="Late Count" :subtitle="(userGeneralInfoData?.general_info?.late_count) || 'N/A'" />
                <v-list-item prepend-icon="mdi-shape" title="Employee Category" :subtitle="(userGeneralInfoData?.general_info?.employee_category) || 'N/A'" />
              </v-col>
            </v-row>
          </v-card>
        </v-card-text>
      </v-card>

      <v-row>
        <v-col cols="12" md="6">
          <v-card variant="outlined" class="h-100">
            <v-card-title class="text-subtitle-1">
              <v-icon class="me-1" size="small">mdi-bank</v-icon>
              Bank Information
            </v-card-title>
            <v-card-text>
              <v-card variant="tonal" class="py-4">
                <v-list-item prepend-icon="mdi-bank" title="Bank" :subtitle="(userGeneralInfoData?.bank_info?.bank?.name) || 'N/A'" />
                <v-list-item prepend-icon="mdi-pound" title="Account Number" :subtitle="(userGeneralInfoData?.bank_info?.account_number) || 'N/A'" />
              </v-card>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" md="6">
          <v-card variant="outlined" class="h-100">
            <v-card-title class="text-subtitle-1">
              <v-icon class="me-1" size="small">mdi-car-info</v-icon>
              Driving Information
            </v-card-title>
            <v-card-text>
              <v-card variant="tonal" class="py-4">
                <v-list-item prepend-icon="mdi-card-account-details" title="License Number" :subtitle="(userGeneralInfoData?.driving_info?.license_number) || 'N/A'" />
                <v-list-item prepend-icon="mdi-calendar-arrow-right" title="Renewal From" :subtitle="(formattedDate(userGeneralInfoData?.driving_info?.renewal_from)) || 'N/A'" />
                <v-list-item prepend-icon="mdi-calendar-arrow-left" title="Renewal To" :subtitle="(formattedDate(userGeneralInfoData?.driving_info?.renewal_to)) || 'N/A'" />
              </v-card>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" md="6">
          <v-card variant="outlined" class="h-100">
            <v-card-title class="text-subtitle-1">
              <v-icon class="me-1" size="small">mdi-account-arrow-right</v-icon>
              Employment Status
            </v-card-title>
            <v-card-text>
              <v-card variant="tonal" class="py-4">
                <v-list-item prepend-icon="mdi-cash-check" title="Payment" :subtitle="(userGeneralInfoData?.employment_status?.payment) || 'N/A'" />
                <v-list-item prepend-icon="mdi-calendar-remove" title="Leaving Date" :subtitle="(userGeneralInfoData?.employment_status?.leaving_date) || 'N/A'" />
                <v-list-item prepend-icon="mdi-text-box" title="Note" :subtitle="(userGeneralInfoData?.employment_status?.note) || 'N/A'" />
                <v-list-item prepend-icon="mdi-help-circle" title="Reason ID" :subtitle="(userGeneralInfoData?.employment_status?.reason_id) || 'N/A'" />
              </v-card>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" md="6">
          <v-card variant="outlined" class="h-100">
            <v-card-title class="text-subtitle-1">
              <v-icon class="me-1" size="small">mdi-file-certificate</v-icon>
              Tax Information
            </v-card-title>
            <v-card-text>
              <v-card variant="tonal" class="py-4">
                <v-list-item prepend-icon="mdi-identifier" title="TIN Number" :subtitle="(userGeneralInfoData?.tax_info?.tin_number) || 'N/A'" />
                <v-list-item prepend-icon="mdi-map-marker-radius" title="Tax Circle" :subtitle="(userGeneralInfoData?.tax_info?.tax_circle) || 'N/A'" />
                <v-list-item prepend-icon="mdi-map-marker-radius" title="Tax Zone" :subtitle="(userGeneralInfoData?.tax_info?.tax_zone) || 'N/A'" />
              </v-card>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-card-text>
  </v-window-item>
</template>

<script setup>
import formattedDate from "@/plugins/dateFormatter.js";

defineProps({
  userGeneralInfoData: {
    type: Object,
    default: () => ({})
  }
})
</script>
